(() => {
  angular.module('finance').controller('finance.views.integrationErrorLog.index', IntegrationErrorLogPageController);

  IntegrationErrorLogPageController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$uibModal',
    'abp.services.finance.integrationErrorLog',
    'moment',
    'appConstants',
  ];

  function IntegrationErrorLogPageController(
    $scope,
    $state,
    $stateParams,
    $uibModal,
    integrationErrorLogSvc,
    moment,
    appConstants
  ) {
    const vm = this;
    vm.loading = 0;
    vm.requestParams = {
      integrationName: $stateParams.integrationName || null,
      internalReferenceId: $stateParams.internalReferenceId || null,
      errorSource: $stateParams.errorSource || null,
      searchText: $stateParams.searchText || null,
      endpoint: $stateParams.endpoint || null,
      skipCount: $stateParams.skipCount || 0,
      maxResultCount: $stateParams.maxResultCount || appConstants.grid.defaultPageSize,
    };
    vm.apiEndpoints = [];
    vm.advancedFiltersAreShown =
      vm.requestParams.errorSource !== null ||
      vm.requestParams.searchText !== null ||
      vm.requestParams.endpoint !== null;

    vm.dateRangeOptions = angular.extend({}, App.createDateRangePickerOptions(), {
      timePicker: true,
    });
    vm.dateRangeOptions.locale.format = 'L LT';
    vm.dateRangeModel = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    };
    if ($stateParams.startDate)
      vm.dateRangeModel.startDate = moment(decodeURIComponent($stateParams.startDate));
    if ($stateParams.endDate)
      vm.dateRangeModel.endDate = moment(decodeURIComponent($stateParams.endDate));

    vm.showAdvancedFilters = showAdvancedFilters;

    vm.gridOptions = {
      appScopeProvider: vm,
      paginationPageSizes: appConstants.grid.defaultPageSizes,
      paginationPageSize: appConstants.grid.defaultPageSize,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'Actions',
          enableSorting: false,
          width: 75,
          headerCellTemplate: '<span></span>',
          cellTemplate: 'actionTemplate',
        },
        {
          field: 'errorSource',
          enableSorting: false,
          width: 30,
          headerCellTemplate: '<span></span>',
          cellTemplate: 'errorSourceTemplate',
        },
        {
          enableSorting: false,
          displayName: App.localize('Time'),
          field: 'creationTime',
          cellFilter: "momentFormat: 'L LTS'",
          minWidth: 150,
        },
        {
          enableSorting: false,
          displayName: App.localize('IntegrationName'),
          field: 'integrationName',
          minWidth: 120,
        },
        {
          enableSorting: false,
          displayName: App.localize('ApiEndpoint'),
          field: 'endpoint',
          minWidth: 150,
        },
        {
          enableSorting: false,
          displayName: App.localize('ErrorSource'),
          field: 'errorSource',
          minWidth: 100,
        },
        {
          enableSorting: false,
          displayName: App.localize('InternalReferenceId'),
          field: 'internalReferenceId',
          cellTemplate: 'internalReferenceTemplate',
          minWidth: 150,
        },
        {
          enableSorting: false,
          displayName: App.localize('ErrorMessage'),
          field: 'errorMessage',
          minWidth: 200,
        },
      ],
      onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        gridApi.pagination.on.paginationChanged(
          $scope,
          App.setPagination(vm.requestParams, vm.getIntegrationErrorLogs)
        );
      },
      data: [],
    };

    vm.getIntegrationErrorLogs = getIntegrationErrorLogs;
    vm.showDetails = showDetails;
    vm.formatInternalReference = formatInternalReference;
    vm.clearFilters = clearFilters;

    init();

    function init() {
      getIntegrationErrorLogs();
    }

    function getIntegrationErrorLogs() {
      registerStateParams();
      vm.loading += 1;

      const params = $.extend({}, vm.requestParams);
      if (vm.dateRangeModel.startDate) {
        params.startDate = vm.dateRangeModel.startDate.format('YYYY-MM-DD');
      }
      if (vm.dateRangeModel.endDate) {
        params.endDate = vm.dateRangeModel.endDate.format('YYYY-MM-DD');
      }

      integrationErrorLogSvc
        .getIntegrationErrorLogs(params)
        .success((data) => {
          vm.gridOptions.totalItems = data.totalCount;
          vm.gridOptions.data = data.items;
          if (data.apiEndpoints) {
            vm.apiEndpoints = data.apiEndpoints;
          }
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function registerStateParams() {
      let startDate = null;
      let endDate = null;
      if (vm.dateRangeModel.startDate) startDate = vm.dateRangeModel.startDate.format('YYYY-MM-DD');
      if (vm.dateRangeModel.endDate) endDate = vm.dateRangeModel.endDate.format('YYYY-MM-DD');

      $state.transitionTo(
        $state.current,
        {
          integrationName: vm.requestParams.integrationName,
          internalReferenceId: vm.requestParams.internalReferenceId,
          errorSource: vm.requestParams.errorSource,
          searchText: vm.requestParams.searchText,
          endpoint: vm.requestParams.endpoint,
          startDate: startDate,
          endDate: endDate,
          skipCount: vm.requestParams.skipCount,
          maxResultCount: vm.requestParams.maxResultCount,
        },
        {
          notify: false,
        }
      );
    }

    function showAdvancedFilters() {
      vm.advancedFiltersAreShown = !vm.advancedFiltersAreShown;
    }

    function formatInternalReference(value) {
      if (!value) return '';
      
      // Check if it's pipe-delimited format
      if (value.includes('|')) {
        const ids = value.split('|').filter(id => id.trim() !== '');
        return ids.join(', ');
      }
      
      return value;
    }

    function clearFilters() {
      vm.requestParams.integrationName = null;
      vm.requestParams.internalReferenceId = null;
      vm.requestParams.errorSource = null;
      vm.requestParams.searchText = null;
      vm.requestParams.endpoint = null;
      vm.requestParams.skipCount = 0;
      vm.requestParams.maxResultCount = appConstants.grid.defaultPageSize;
      vm.dateRangeModel.startDate = moment().startOf('day');
      vm.dateRangeModel.endDate = moment().endOf('day');
      vm.getIntegrationErrorLogs();
    }

    function showDetails(integrationErrorLog) {
      $uibModal.open({
        templateUrl: require('./detailModal.html'),
        controller: 'finance.views.integrationErrorLog.detailModal as vm',
        backdrop: 'static',
        resolve: {
          errorLog: () => integrationErrorLog,
        },
      });
    }
  }
})();
